import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "./UserSelectionPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function UserSelectionPage() {

  const [alumni, setAlumni] = useState([]);
  const [search, setSearch] = useState("");

  /* ========================================
     FETCH APPROVED ALUMNI
  ======================================== */
  useEffect(() => {

    const fetchAlumni = async () => {
      try {

        const res = await axios.get(
          `${API_BASE_URL}/current-alumni/approved`
        );

        setAlumni(res.data || []);

      } catch (err) {
        console.error("Failed to fetch alumni:", err);
      }
    };

    fetchAlumni();

  }, []);



  /* ========================================
     SEARCH FILTER
  ======================================== */
  const filteredAlumni = useMemo(() => {

    return alumni.filter((a) => {

      const fullName = [
        a.title,
        a.firstName,
        a.middleName,
        a.lastName
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      const searchText = search.toLowerCase();

      return (
        a.alumniID?.toLowerCase().includes(searchText) ||
        fullName.includes(searchText)
      );

    });

  }, [alumni, search]);



  /* ========================================
     UPDATE POSITION
  ======================================== */
  const handlePositionChange = async (id, value) => {

    try {

      await axios.patch(`${API_BASE_URL}/users/position/${id}`, {
        position: value
      });

      setAlumni(alumni.map(a =>
        a._id === id ? { ...a, position: value } : a
      ));

    } catch (err) {
      console.error(err);
    }

  };



  /* ========================================
     UPDATE SYSTEM ROLE
  ======================================== */
  const handleRoleChange = async (id, value) => {

    try {

      await axios.patch(`${API_BASE_URL}/users/system-role/${id}`, {
        systemRole: value
      });

      setAlumni(alumni.map(a =>
        a._id === id ? { ...a, systemRole: value } : a
      ));

    } catch (err) {
      console.error(err);
    }

  };



  /* ========================================
     UPDATE STATUS
  ======================================== */
  const handleStatusChange = async (id, value) => {

    try {

      await axios.patch(`${API_BASE_URL}/users/status/${id}`, {
        status: value
      });

      setAlumni(alumni.map(a =>
        a._id === id ? { ...a, status: value } : a
      ));

    } catch (err) {
      console.error(err);
    }

  };



  return (
    <div className="user-selection-page">

      {/* PAGE TITLE */}
      <h1 className="selection-title">User Selection</h1>


      {/* SEARCH */}
      <div className="selection-search-box">

        <input
          type="text"
          placeholder="Search by Alumni ID or Name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      </div>



      {/* TABLE */}
      <div className="selection-table-card">

        <table className="selection-table">

          <thead>
            <tr>
              <th>SN</th>
              <th>AlumniID</th>
              <th>Fullname</th>
              <th>Position</th>
              <th>System Role</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>

            {filteredAlumni.map((a, index) => {

              const fullName = [
                a.title,
                a.firstName,
                a.middleName,
                a.lastName
              ]
                .filter(Boolean)
                .join(" ");

              const isProtected = a.systemRole === "SYSTEM ADMIN";

              return (

                <tr
                  key={a._id}
                  className={isProtected ? "protected-row" : ""}
                >

                  <td>{index + 1}</td>

                  <td>{a.alumniID}</td>

                  <td>{fullName}</td>


                  {/* POSITION */}
                  <td>

                    <select
                      value={a.position || "MEMBER"}
                      disabled={isProtected}
                      onChange={(e) =>
                        handlePositionChange(a._id, e.target.value)
                      }
                    >

                      <option value="MEMBER">MEMBER</option>
                      <option value="EXECUTIVE">EXECUTIVE</option>

                    </select>

                  </td>


                  {/* SYSTEM ROLE */}
                  <td>

                    <select
                      value={a.systemRole || "MEMBER"}
                      disabled={isProtected}
                      onChange={(e) =>
                        handleRoleChange(a._id, e.target.value)
                      }
                    >

                      <option value="MEMBER">MEMBER</option>
                      <option value="ADMIN">ADMIN</option>
                      <option value="SYSTEM ADMIN">SYSTEM ADMIN</option>

                    </select>

                  </td>



                  {/* STATUS */}
                  <td>

                    <select
                      value={a.status || "ACTIVE"}
                      disabled={isProtected}
                      onChange={(e) =>
                        handleStatusChange(a._id, e.target.value)
                      }
                    >

                      <option value="ACTIVE">ACTIVE</option>
                      <option value="INACTIVE">INACTIVE</option>

                    </select>

                  </td>

                </tr>

              );

            })}

          </tbody>

        </table>

      </div>

    </div>
  );
}